import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

export const ThemeToggle: React.FC = () => {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== 'undefined') {
      return document.documentElement.classList.contains('dark');
    }
    return false;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      className="relative glass-button p-2 rounded-lg group"
      aria-label="Toggle theme"
    >
      <div className="relative w-5 h-5">
        <Sun
          className={`w-5 h-5 absolute inset-0 transform transition-transform duration-500 rotate-0 ${
            isDark ? 'rotate-180 opacity-0' : 'rotate-0 opacity-100'
          } text-yellow-500`}
        />
        <Moon
          className={`w-5 h-5 absolute inset-0 transform transition-transform duration-500 ${
            isDark ? 'rotate-0 opacity-100' : '-rotate-180 opacity-0'
          } text-indigo-400`}
        />
      </div>
      <div className="absolute inset-0 rounded-lg ring-2 ring-indigo-500/20 dark:ring-indigo-400/20 transition-opacity duration-300 opacity-0 group-hover:opacity-100" />
    </button>
  );
};

export default ThemeToggle;